<!-- <iframe  [src]="updateVideoUrl()" width='100%' height='100%' scrolling='yes' style='border:0'></iframe> -->
<button type="button" class="btn btn-primary" style="background-color: #043C5A" [routerLink]="['../../appointment/']"><i class="fas fa-angle-left"></i> Back</button>

<div *ngIf="!captcha" class="mt-3">
  <re-captcha (resolved)="resolved($event)"

              siteKey="6LeMhXsaAAAAAJGLeSpf_zsNhZkZm8edYQwKXIwK">
  </re-captcha>

</div>

<div style="height: 100%" [ngClass]="captcha ? '' : 'd-none'">
  <div style="height: 100%" *ngIf="data == 'lacassessorpublicservices'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorPublicServices@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessordisabledveterans'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorDisabledVeterans@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessormajorexemptions'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorMajorExemptions@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessordatasales'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorDataSales@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessoreastdistrict'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorEastDistrict@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessorgismapping'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorGISMapping@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessorhomeownersexemption'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorHomeownersExemption@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessorwestdistrict'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorWestDistrict@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessormanufacturedhomes'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorManufacturedHomes@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessorownershipservices'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorOwnershipServices@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessorpublicinformationofficer'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorPublicInformationOfficer@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessorsouthdistrict'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorSouthDistrict@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessornorthdistrict'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorNorthDistrict@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessorlancasterdistrict'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorLancasterDistrict@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessormajorrealproperty'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorMajorRealProperty@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessorspecialinvestigations'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorSpecialInvestigations@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>

  <div style="height: 100%" *ngIf="data == 'lacassessorbusinesspersonalproperty'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorBusinessPersonalProperty@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>
  <div style="height: 100%" *ngIf="data == 'lacassessormarineaircraft'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorMarineAircraftAirlines@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>
  <div style="height: 100%" *ngIf="data == 'lacassessormajorpersonalproperty'">
    <iframe src='https://outlook.office365.com/owa/calendar/LACAssessorMajorPersonalProperties@lacounty.onmicrosoft.com/bookings/' width='100%' height='100%' scrolling='yes' style='border:0'></iframe>
  </div>
</div>
